import { Grid } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import Events from "./Events";
import Tasks from "../Dcp Tutoring/Tasks";
import ProgressBar from "../Dcp Tutoring/ProgressBar";
import { ServiceOffer } from "../../common/const";
import SessionHistory from "../Dcp Tutoring/SessionHistory";
import Resource from "../Dcp Tutoring/Resource";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { getScoreStats } from "../../api/scoreApi";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import SubjectOverview from "../Dcp Tutoring/SubjectOverview";
import { getAllAssignSubject, getAllSubject } from "../../api/subjectApi";

const ApAcademicTutoring = ({
    currentService,
    studentId,
    currentGrade
}) => {
    const dispatch = useDispatch();
    const { loading, user  } = useSelector((state) => state.auth);
    const [progressData, setProgressData] = useState(null);
    const [subjectList, setSubjectList] = useState([]);
    const [apSubject, setApSubject] = useState([]);
    const pageNo = 1;
    const pageSize = 100;

    const getStats = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getScoreStats(currentService, studentId);
            dispatch(setLoading({
                loading: false
            }));
            setProgressData(response.data);
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    };

    useEffect(() => {
        getStats();
        getSubjects();
        if (currentService === ServiceOffer.tutor) {
            getAssignedSubject();
        }
    }, [currentService]);

    const getSubjects = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getAllSubject(pageNo, pageSize, currentService, ServiceOffer.academic === currentService ? currentGrade : '');
            setSubjectList(response?.data?.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    };

    const getAssignedSubject = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getAllAssignSubject(currentService, studentId);
            setApSubject(response?.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    };


    return (
        <Fragment>
            <Grid container spacing={2}>
                {loading && (
                    <LoadingSpinner />
                )}
                <Grid item sm={12}>
                    <ProgressBar progressData={progressData} fromMentor />
                </Grid>
                <Grid item md={6} sm={12}>
                    <Events currentService={currentService} studentId={studentId} />
                </Grid>
                <Grid item md={6} sm={12}>
                    <SubjectOverview studentId={studentId} currentService={currentService} fromMentor label={currentService === ServiceOffer.academic ? 'Subject Performance' : 'Enrolled Subjects'} currentGrade={currentGrade} />
                </Grid>
                <Grid item md={6} sm={12}>
                    <Tasks
                        label={currentService === ServiceOffer.academic ? 'Homework & Tasks' : 'Assigned Tasks'}
                        fromMentor
                        options={ServiceOffer.tutor === currentService ? apSubject.map((a) => ({
                            label: a?.subject?.name,
                            value: a.student_subject_id
                        })) : subjectList.map((a) => ({
                            label: a.name,
                            value: a.subject_id
                        }))}
                        currentService={currentService} studentId={studentId}
                    />
                </Grid>
                <Grid item md={6} sm={12}>
                    <Resource
                        fromMentor
                        studentId={studentId}
                        currentService={currentService}
                    />
                </Grid>
                <Grid item md={12} sm={12}>
                    <SessionHistory
                        fromMentor
                        studentId={studentId}
                        currentService={currentService}
                    />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default ApAcademicTutoring;